'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var clsx = require('clsx');
var QuestionMark = require('@narvar/nth-bit-icon-question-mark');
var nthHookSettings = require('@narvar/nth-hook-settings');
var nthHookTheme = require('@narvar/nth-hook-theme');
var nthHookTranslations = require('@narvar/nth-hook-translations');
var nthHookContextAnalytics = require('@narvar/nth-hook-context-analytics');
var nthKitChat = require('@narvar/nth-kit-chat');
var TextLink = require('@narvar/nth-bit-text-link');
var CpCustomComponent = require('@narvar/nth-block-cp-custom-component');
var HelpPill_module = require('./HelpPill.module.css.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var clsx__default = /*#__PURE__*/_interopDefaultLegacy(clsx);
var QuestionMark__default = /*#__PURE__*/_interopDefaultLegacy(QuestionMark);
var TextLink__default = /*#__PURE__*/_interopDefaultLegacy(TextLink);
var CpCustomComponent__default = /*#__PURE__*/_interopDefaultLegacy(CpCustomComponent);

const HelpPill = ({
  featureName
}) => {
  const {
    helpPill
  } = nthHookSettings.useSettings();

  // FIXME: temp hacky solution to allow both chat and pill on page
  const {
    state: {
      chatExists
    }
  } = nthKitChat.useChatUIState();
  const {
    helpPageHref,
    showIcon: showIconIn,
    showText: showTextIn,
    displayIconLast,
    customComponentSettingsId
  } = helpPill || {};
  const showIcon = showIconIn === null || showIconIn === undefined || showIconIn;
  const showText = showTextIn === null || showTextIn === undefined || showTextIn;
  const {
    helpPillText = ''
  } = nthHookTranslations.useTranslations();
  const {
    floatingpillNoneNone: pillStyle
  } = nthHookTheme.useTheme();
  const logEvent = nthHookContextAnalytics.useAnalyticsPost();
  const [postMessage, setPostMessageImpl] = React.useState(() => () => {});
  const setPostMessage = React.useCallback(value => {
    setPostMessageImpl(() => value);
  }, [setPostMessageImpl]);
  const onClick = React.useCallback(() => {
    logEvent({
      clickCategory: nthHookContextAnalytics.NarvarClickSubTypes.EXTERNAL_HELP_LINK,
      clickLinkDestinationUrl: helpPageHref,
      clickLinkLabel: helpPillText,
      clickSubType: nthHookContextAnalytics.NarvarClickSubTypes.EXTERNAL_HELP_LINK,
      clickType: nthHookContextAnalytics.NarvarClickTypes.OUTGOING,
      eventComponent: nthHookContextAnalytics.NarvarEventComponents.NTH_BLOCK_HELP_PILL,
      eventFeature: nthHookContextAnalytics.NarvarEventComponents.NTH_BLOCK_HELP_PILL,
      eventType: nthHookContextAnalytics.NarvarEventTypes.CLICK,
      feature: featureName,
      pageComponent: nthHookContextAnalytics.NarvarEventComponents.NTH_BLOCK_HELP_PILL
    });
    if (customComponentSettingsId) {
      postMessage({
        type: 'onHelpPillClick'
      });
    }
  }, [logEvent, postMessage, customComponentSettingsId, helpPageHref, helpPillText, featureName]);
  const [isOpen, setIsOpen] = React.useState(false);
  if (!helpPageHref && !customComponentSettingsId) return null;
  const contents = [showIcon && /*#__PURE__*/React__default["default"].createElement("div", {
    key: "helpPillIcon",
    style: {
      padding: 0
    }
  }, /*#__PURE__*/React__default["default"].createElement(QuestionMark__default["default"], {
    featureName: featureName,
    containerCustomStyle: {
      width: '2rem'
    }
  })), showText && /*#__PURE__*/React__default["default"].createElement("div", {
    key: "helpPillText",
    style: {
      display: showIcon ? 'inherit' : 'none',
      padding: '0 0.5rem'
    }
  }, helpPillText)];
  if (displayIconLast) contents.reverse();
  const containerClasses = clsx__default["default"]({
    [HelpPill_module["default"].container]: true,
    [HelpPill_module["default"].containerOpen]: isOpen
  });
  return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement("button", {
    className: HelpPill_module["default"].button,
    type: "button",
    style: {
      // FIXME: temp hacky solution to allow both chat and pill
      bottom: chatExists ? '6rem' : '1rem'
    },
    "data-test": "helpPillFeature",
    "aria-label": !customComponentSettingsId && helpPageHref ? `External link to ${helpPageHref}` : undefined
  }, /*#__PURE__*/React__default["default"].createElement(TextLink__default["default"], {
    href: !customComponentSettingsId && helpPageHref ? helpPageHref : '',
    target: !customComponentSettingsId && helpPageHref ? TextLink.TextLinkTargetType.BLANK : undefined,
    rel: "noreferrer noopener",
    linkStyle: {
      sDefault: {
        color: '#fff',
        backgroundColor: '#000000',
        borderRadius: '5rem',
        padding: '0.375rem',
        display: 'block',
        ...pillStyle
      },
      sHover: {
        backgroundColor: '#000000',
        textDecoration: 'none'
      }
    },
    onClick: onClick
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    className: HelpPill_module["default"].linkContents,
    "data-testid": "help-pill-grid-row"
  }, contents.map(content => content)))), customComponentSettingsId && /*#__PURE__*/React__default["default"].createElement("div", {
    role: "group",
    className: containerClasses
  }, /*#__PURE__*/React__default["default"].createElement(CpCustomComponent__default["default"], {
    key: "helpPillCustomComponent",
    featureName: "customComponent",
    componentId: customComponentSettingsId,
    postMessageRef: setPostMessage,
    onIsHelpWidgetOpenChange: setIsOpen
  })));
};
var HelpPill$1 = nthHookSettings.withSettingsProvider(nthHookTranslations.withTranslationsProvider(nthHookTheme.withThemeProvider(HelpPill, {
  themeTokens: ['floatingpillNoneNone']
}), {
  translationKeys: ['helpPillText']
}), {
  settingsRequested: `
      helpPill {
        helpPageHref
        showIcon
        showText
        displayIconLast
        customComponentSettingsId
      }
    `
});

exports["default"] = HelpPill$1;
